import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestedSignaturesComponent } from './requested-signatures/requested-signatures.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { TableModule } from '../../components/table/table.module';
import { ReviewRequestedSignaturesComponent } from './review-requested-signatures/review-requested-signatures.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@NgModule({
  declarations: [
    RequestedSignaturesComponent,
    ReviewRequestedSignaturesComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatAccordion,
    MatExpansionModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatSelectModule,
    MatInputModule,
    PdfViewerModule,
    MatDatepickerModule,
    MatSlideToggleModule,
  ]
})
export class RequestedSignaturesModule { }
